import React from 'react';
import styled from 'styled-components';

import bacground from '@/public/subscribe_bg.webp';
import { backgroundImageMixin } from '@/styles/BackgroundimageMixin';

export const SubscribeLayouts = ({ children }) => {
  return (
    <Wrapper>
      <Content>{children}</Content>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;

  overflow: hidden;
  position: relative;
  ${backgroundImageMixin(bacground.src)}
`;

const Content = styled.div``;
